import React from 'react'

const Expert = () => {
  return (
    <div>Expert</div>
  )
}

export default Expert